import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { SelectItem } from '@web/shared/ui';
import { CollectionRequestBuilder } from '@web/common';
import { Nillable } from '@web/utils';
import { AdminWarehouseGoodApiService } from '../api/services/admin-warehouse-good-api.service';
import { AdminWarehouseGoodCollectionItemResponse } from '../api/responses/admin-warehouse-good-collection-item.response';

@Injectable({
  providedIn: 'root',
})
export class AdminWarehouseGoodSelectItemsProviderService {
  private readonly warehouseGoodApi = inject(AdminWarehouseGoodApiService);
  private readonly collectionRequestBuilder = inject(CollectionRequestBuilder);

  /* prettier-ignore */
  public fetchCollectionAsSelectItems<Key extends keyof AdminWarehouseGoodCollectionItemResponse>(key: Key, query: Nillable<string> = null): Observable<SelectItem<AdminWarehouseGoodCollectionItemResponse[Key]>[]> {
    return this.warehouseGoodApi
      .fetchCollection(
        this.collectionRequestBuilder
          .query(query)
          .page(1)
          .pageSize(90)
          .sorts((builder) => [builder.ascendingFor('name').build()])
          .build(),
        { skipByLoading: true }
      )
      .pipe(
        map(({ items }) =>
          items.map((item) => {
            const label = `${item.sku} | (${item.quantity}) | ${item.name}`;

            return new SelectItem(label, item[key]);
          }),
        ),
        catchError(() => of([])),
      );
  }
}
